var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"variant":"info"}},[_c('feather-icon',{staticClass:"mr-25",attrs:{"icon":"EyeIcon","size":"12"}}),_vm._v(" "+_vm._s(_vm.field)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }